import React, { useEffect, useState } from "react";
import Logo from "../../../Images/logoIcon.png";
import MenuIcone from "../../../Images/menuicone.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  MdBookmarkAdd,
  MdDashboard,
  MdFileCopy,
  MdFileOpen,
  MdFilePresent,
  MdGroups,
  MdGroups2,
  MdHome,
  MdLeaderboard,
  MdWallet,
} from "react-icons/md";
import {
  FaArrowUp,
  FaComment,
  FaComments,
  FaFile,
  FaHome,
  FaRegClipboard,
} from "react-icons/fa";
import { SiHelpscout } from "react-icons/si";
import { LuLogOut } from "react-icons/lu";
import { IoNewspaperOutline, IoTrophy } from "react-icons/io5";
import {
  TbBuildingBank,
  TbFile,
  TbFileAnalytics,
  TbUsersPlus,
} from "react-icons/tb";
import { useTranslation } from "react-i18next";
import { HiMenuAlt2 } from "react-icons/hi";
import { useUser } from "../../../hooks/use-user";
import {
  BsFillCollectionPlayFill,
  BsGlobe,
  BsHeadphones,
} from "react-icons/bs";
import { FaAward, FaWallet } from "react-icons/fa";
import { MdKeyboardArrowDown } from "react-icons/md";
import { FaArtstation } from "react-icons/fa6";
import { GoDotFill } from "react-icons/go";
import { IoMdBook, IoMdBookmark, IoMdLogOut } from "react-icons/io";
import { TbBrandStackshare } from "react-icons/tb";
import {
  FaWhatsapp,
  FaInstagram,
  FaFacebook,
  FaTwitter,
  FaCopy,
} from "react-icons/fa";
import { motion } from "framer-motion";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
} from "@chakra-ui/react";
import axios from "../../../axios";
import DemoUser from "../../../Images/demoUserForNavbar.jpg";
import {
  Bell,
  BookAIcon,
  BookOpen,
  File,
  FileUserIcon,
  Group,
  Headphones,
  Home,
  HomeIcon,
  Landmark,
  LeafyGreen,
  NewspaperIcon,
  ScrollText,
  UserPlus,
  Wallet,
} from "lucide-react";
import { toast } from "react-toastify";
import ProfileAvatar from "../../../componant/Avatar/ProfileAvatar";
import { TrophySpin } from "react-loading-indicators";
import {
  getInstituteLogo,
  getInstituteName,
  getUserInstituteId,
  useInstitute,
} from "../../../hooks/use-institute";

const Navbar = () => {
  const { data: user } = useUser();
  const linkedInstituteId = getUserInstituteId(user);
  const { data: institute } = useInstitute(linkedInstituteId);
  const brandName = getInstituteName(institute) || "Adhyayi";
  const brandLogo = getInstituteLogo(institute) || Logo;
  const isLinkedBrand = Boolean(linkedInstituteId && institute);
  // console.log(user);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();

  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMenuOpen2, setIsMenuOpen2] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);
  const [vlaue, setVlue] = useState("");
  const [pro, setPro] = useState("");
  const [customMessage, setCustomMessage] = useState("");
  const [copied, setCopied] = useState(false);
  const isContestValid = user?.isContestValid === true;
  const [states, setStates] = useState([]);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const toggleDropdown = () => {
    setIsOpen1(!isOpen1);
  };
  const toggleMenu2 = () => {
    setIsMenuOpen2(!isMenuOpen2);
    console.log("clcik");
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };
  const closeMenu2 = () => {
    setIsMenuOpen2(false);
  };

  const [t, i18n] = useTranslation();

  const stHinmdi = () => {
    //  console.log(i18n.language)
    if (i18n.language == "en") {
      i18n.changeLanguage("hi");
    } else if (i18n.language == "hi") {
      i18n.changeLanguage("en");
    }
  };
  const ChageLang = (lang) => {
    if (lang == "en") {
      i18n.changeLanguage("en");
      setShowModal(false);
      // setMobileOpen(false);
    } else if (lang == "hi") {
      i18n.changeLanguage("hi");
      setShowModal(false);
      // setMobileOpen(false);
    }
  };
  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setShowModal(false);
  };

  const getLinkClass = (path) => {
    return location.pathname === path
      ? "flex items-center p-2 text-purple bg-purple-100 rounded-lg dark:text-purple-400 group font-bold"
      : "flex items-center p-2 text-gray-900 rounded-lg dark:text-black group font-bold";
  };
  const [referralCode, setReferralCode] = useState("");

  useEffect(() => {
    const fetchReferralCode = async () => {
      try {
        const res = await axios.get("/referral/stats");
        if (res.data?.result?.referralCode) {
          setReferralCode(res.data.result.referralCode);
        }
      } catch (error) {
        console.error("Referral code fetch error", error);
      }
    };
    fetchReferralCode();
  }, []);

  const userState = user?.userState || user?.state || user?.stateName || "";

  const shareableLink = referralCode
    ? `https://learn2earn24x7.com/login?ref=${referralCode}`
    : "";

  const handleShare = (platform) => {
    const shareText = `Join Adhyayi and start earning while learning! Use my referral code: ${referralCode}\n${shareableLink}`;
    let url;
    switch (platform) {
      case "whatsapp":
        url = `https://api.whatsapp.com/send?text=${encodeURIComponent(
          shareText,
        )}`;
        break;
      case "instagram":
        url = `https://instagram.com/share?url=${encodeURIComponent(
          shareableLink,
        )}`;
        break;
      case "facebook":
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          shareableLink,
        )}`;
        break;
      case "twitter":
        url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
          shareableLink,
        )}&text=${encodeURIComponent(customMessage)}`;
        break;
      default:
        return;
    }
    window.open(url, "_blank");
  };

  const copyToClipboard = () => {
    try {
      navigator.clipboard.writeText(shareableLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Clipboard write failed", err);
    }
  };

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const res = await axios.get("/all");
       
        setStates(res.data?.data || []);
      } catch (err) {
        toast(err.response?.data?.message || "Failed to fetch states", 3000);
      }
    };

    fetchStates();
  }, []);

  // USER STATE
  const fullStateName = user?.userState || user?.state || user?.stateName || "";

  // FIND SHORT FORM FROM API DATA
  const matchedState = states.find((item) => item.fullName === fullStateName);

  const userStateShort = matchedState?.shortName || fullStateName;

  return (
    <>
      <nav className="border-gray-200 fixed top-0 z-[60] lg:h-20 h-16 ">
        {/* <div className="flex items-center justify-between "> */}
        {/* Hamburger Icon on the left side */}
        {/* <button
            type="button"
            className="flex items-center text-sm md:hidden"
            onClick={toggleMenu}
          >
            <HiMenuAlt2 size={30} />
          </button> */}

        {/* Logo in the center */}
        <nav className="bg-white border-gray-200 fixed top-0  left-0 w-full z-50 shadow-xl lg:h-20 h-12">
          <div className="flex h-full items-center justify-between px-3 lg:p-1">
            {/* Hamburger Icon on the left side */}
            <button
              type="button"
              className="flex items-center text-sm md:hidden"
              onClick={toggleMenu}
            >
              {/* <HiMenuAlt2 size={30} /> */}
              <img src={MenuIcone} alt="" className="w-8" />
            </button>

            {/* Logo */}
            <div className="hidden lg:block text-2xl font-bold">
              <a href="/" className="flex items-center gap-2">
                <img
                  className="w-14 h-14 object-contain rounded-md"
                  src={brandLogo}
                  alt={`${brandName} Logo`}
                />

                <span
                  className={`text-bgBlue font-agrandir ${
                    isLinkedBrand
                      ? "max-w-[240px] truncate text-xl tracking-normal"
                      : "text-3xl tracking-[2px]"
                  }`}
                  title={brandName}
                >
                  {brandName}
                </span>
              </a>
            </div>

            {/* Avatar on the right side */}
            <div className="flex items-center gap-2">
              <div className="text-start hidden  lg:block">
                <p className="text-lg font-bold text-bgBlue ">
                  {user?.name || "User"}
                </p>
                <p className="text-bgBlue">
                  {user?.email || "user@example.com"}
                </p>
              </div>
              <button
                onClick={() => navigate("/dash/profileNew")}
                className="flex text-sm bg-bgBlue rounded-full focus:ring-2 focus:ring-bgBlue dark:focus:ring-bgBlue mr-4 "
              >
                {/* Profile Image */}
                <ProfileAvatar
                  user={user}
                  className="hidden sm:flex h-14 w-14 shrink-0 items-center justify-center text-lg"
                />{" "}
              </button>
              <div className="lg:hidden flex flex-row gap-2 items-center">
                <Link to="/dash/leaderBoard">
                  <MdLeaderboard size={24} />
                </Link>
                <Link to="/dash/wallet" className="inline-flex items-center">
                  <Wallet size={24} />
                </Link>
              </div>
            </div>

            {/* <div
                className={`w-40 absolute z-50 right-4 top-0   ${
                  isMenuOpen2 ? "" : "hidden"
                } text-base list-none bg-bgBlue divide-gray-100 rounded-lg shadow dark:bg-gray-700 dark:divide-gray-600`}
                id="user-dropdown"
              >
                <button
                  type="button"
                  className="absolute top-0 right-0 p-2 text-gray-400 hover:text-gray-500 dark:text-gray-300 dark:hover:text-gray-200 font-semibold"
                  onClick={closeMenu2}
                >
                  <svg
                    className="w-6 h-6 font-semibold"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
                <ul
                  className="py-8 flex flex-col justify-start text-start px-4 font-oswald font-semibold"
                  aria-labelledby="user-menu-button"
                >
                  <li>
                    <a
                      href="#"
                      className="block  py-2 text-lg text-bgBlue hover:bg-gray-100 dark:hover:bg-gray-600  dark:hover:text-white"
                    >
                      My Account
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="block  py-2 text-lg text-bgBlue hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white"
                    >
                      Wallet
                    </a>
                  </li>
                  <li
                    onClick={() => {
                      localStorage.removeItem("logintoken");
                      window.location.reload();
                      // history.push("/mainPage5data");
                    }}
                  >
                    <a
                      href="#"
                      className="block  py-2 text-lg text-bgBlue hover:bg-gray-100 dark:hover:bg-gray-600  dark:hover:text-white"
                    >
                      Logout
                    </a>
                  </li>
                </ul>
              </div> */}
          </div>
        </nav>

        {/* Avatar on the right side */}
        {/* <div className="flex items-center gap-2">
            <button
              onClick={toggleMenu2}
              className="flex text-sm bg-gray-800 rounded-full focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600"
            >
              <img className="w-14  rounded-full" src={pro} alt="user photo" />
            </button>
            <div className="text-start">
              <p className="text-lg font-bold text-bgBlue">{user?.name}</p>
              <p className="text-bgBlue">{user?.email}</p>
            </div>
          </div> */}

        {/* <div
          className={`w-60 absolute z-50 right-4 top-16 border border-purple p-2  ${
            isMenuOpen2 ? "" : "hidden"
          } text-base list-none bg-bgWhite rounded-xl`}
          id="user-dropdown"
        >
          <button
            type="button"
            className="absolute top-0 right-0 p-2 text-purple hover:text-gray-500 dark:text-gray-300 dark:hover:text-gray-200 font-semibold"
            onClick={closeMenu2}
          >
            <svg
              className="w-6 h-6 font-semibold"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <br />
          <div className="w-full flex flex-col justify-center items-center ">
            <div className="flex flex-col gap-2 justify-center items-center  text-bgBlue font-oswald  ">
              <div className="w-1/3 m-auto ">
                <img src={pro} alt="" className="rounded-full border  m-auto" />
              </div>

              <div className=" ">
                <h1 className="text-sm font-bold">{user?.name}</h1>

                <p className="text-sm">{user?.email}</p>
              </div>
            </div>
            <div className="w-full flex gap-4 justify-between items-center p-2  text-bgBlue font-oswald  ">
              <div className="ml-4 ">
                <p className="text-sm text-green font-semibold">
                  Active Course
                </p>
              </div>

              <div className=" mr-4 text-purple cursor-pointer">
                <IoMdLogOut
                  size={25}
                  onClick={() => {
                    localStorage.removeItem("token");
                    navigate("/login");
                  }}
                />
              </div>
            </div>
          </div>
        </div> */}
      </nav>

      {/* Sidebar */}
      <div
        className={`fixed inset-0 z-[70] transition-transform ${
          isMenuOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        {/* Overlay */}
        <div className="fixed inset-0 bg-black/40" onClick={closeMenu}></div>

        {/* Sidebar */}
        <div className="relative w-72 h-full bg-[#F4F0FA]  shadow-xl p-2 flex flex-col">
         

          {/* Menu Items */}
          <div className="flex flex-col gap-2 text-xl">
            {[
              { name: "Home", icon: <MdHome />, path: "/dash/home" },
              { name: "Mock Test", icon: <BookOpen />, path: "/dash/plan" },
              { name: "Contest", icon: <MdFileCopy />, path: "/dash/contest" },
              {
                name: "Leader Board",
                icon: <MdLeaderboard />,
                path: "/dash/leaderBoard",
              },

              {
                name: "Current Affairs",
                icon: <ScrollText />,
                path: "/dash/current-affairs",
              },
              {
                name: userStateShort ? `${userStateShort} GK` : "State GK",
                subtitle: "",
                icon: <Landmark />,
                path: "/dash/state-gk",
              },

              { name: "Wallet", icon: <FaWallet />, path: "/dash/wallet" },
              {
                name: "Refer & Get Credits",
                icon: <MdGroups />,
                path: "/dash/referral",
              },
              { name: "Language", icon: <BsGlobe />, action: toggleDropdown },

              {
                name: "Support",
                icon: <BsHeadphones />,
                path: "/dash/support",
              },
            ].map((item, i) => {
              const isActive = location.pathname === item.path;

              return (
                <div
                  key={i}
                  onClick={() => {
                    if (item.path) {
                      navigate(item.path);
                      closeMenu();
                    } else if (item.action) {
                      item.action();
                    }
                  }}
                  className={`flex pl-10 gap-2 px-2 py-1 rounded-full cursor-pointer transition
              ${
                isActive
                  ? "bg-white shadow text-[#F5A623] font-semibold py-2 px-2"
                  : "text-[#4B2D83] hover:bg-white/70 py-2"
              }`}
                >
                  <div className="text-xl">{item.icon}</div>
                  <span>{item.name}</span>
                </div>
              );
            })}

            {/* Logout */}
            <div
              onClick={() => {
                localStorage.removeItem("token");
                localStorage.removeItem("pendingRefCode");
                navigate("/login");
              }}
              className="flex pl-10 gap-4 px-2 py-3 rounded-xl cursor-pointer text-[#4B2D83] hover:bg-white mt-0"
            >
              <LuLogOut />
              <span>Logout</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
